import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import Navbar from "./common/Navbar";
import Footer from "./common/Footer";

const TermsAndConditions = () => {
  return (
    <>
    <Navbar />
    <Container>
      <Box className="text-center" mt={12} mb={5}>
        <Typography variant="h4" component="h3" gutterBottom>
          Terms and Conditions For Beryls Management Limited
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Last updated: September 24, 2024
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Please read these terms and conditions carefully before using Our Service.
        </Typography>
      </Box>

      {/* Body Section */}
      <Box className="terms-content">
        <Typography variant="h5" sx={{fontWeight: 600}} component="h2" gutterBottom>
          Interpretation and Definitions
        </Typography>

        <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>
          Interpretation
        </Typography>
        <Typography variant="body1" paragraph>
          Words where the initial letter is capitalized have meanings defined under the following
          conditions. The following definitions shall have the same meaning regardless of whether
          they appear in singular or plural.
        </Typography>

        <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>
          Definitions
        </Typography>
        <Typography variant="body1" paragraph>
          For the purposes of these Terms and Conditions:
        </Typography>

        <ul>
          <li>
            <Typography variant="body1">
              <strong>Affiliate</strong> means an entity that controls, is controlled by, or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest, or other securities entitled to vote for election of directors or other managing authority
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Country</strong> refers to: Nigeria
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Beryls Management Limited, 502, Ikorodu Road, Lagos.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Device</strong> means any device that can access the Service, such as a computer, cellphone, or digital tablet.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Service</strong> refers to the Website.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Terms and Conditions</strong> (also referred to as "Terms") mean these Terms and Conditions that form the entire agreement between You and the Company regarding the use of the
              Service.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Third-party Social Media Service</strong> means any services or content (including data,
              information, products, or services) provided by a third party that may be displayed, included,
              or made available by the Service.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Website</strong> refers to Beryls Management Limited, accessible from http://www.berylsfinancials.com
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable
            </Typography>
          </li>
        </ul>

        <Divider style={{ margin: "20px 0" }} />

        <Typography variant="h5" sx={{fontWeight: 600}} component="h2" gutterBottom>
          Acknowledgment
        </Typography>
        <Typography variant="body1" paragraph>
          These are the Terms and Conditions governing the use of this Service and the agreement that
          operates between You and the Company. These Terms set out the rights and obligations of
          all users regarding the use of the Service.
        </Typography>
        <Typography variant="body1" paragraph>
          Your access to and use of the Service is conditioned on Your acceptance of and compliance
          with these Terms. These Terms apply to all visitors, users, and others who access or use the
          Service.
        </Typography>

        <Typography variant="body1" paragraph>
          By accessing or using the Service, You agree to be bound by these Terms. If You disagree with
          any part of these Terms, then You may not access the Service.
        </Typography>

        <Typography variant="body1" paragraph>
          You represent that you are over the age of 18. The Company does not permit those under 18
          to use the Service.
        </Typography>

        <Typography variant="body1" paragraph>
          Your access to and use of the Service is also conditioned on Your acceptance of and
          compliance with the Company's Privacy Policy. Our Privacy Policy describes Our policies and
          procedures on the collection, use, and disclosure of Your personal information when You use
          the Application or the Website and informs You of Your privacy rights and how the law
          protects You. Please read Our Privacy Policy carefully before using Our Service
        </Typography>

        <Divider style={{ margin: "20px 0" }} />

        <Typography variant="h5" sx={{fontWeight: 600}} component="h2" gutterBottom>
          Links to Other Websites
        </Typography>
        <Typography variant="body1" paragraph>
          Our Service may contain links to third-party websites or services that are not owned or
          controlled by the Company. The Company has no control over, and assumes no responsibility
          for, the content, privacy policies, or practices of any third-party websites or services. You
          further acknowledge and agree that the Company shall not be responsible or liable, directly
          or indirectly, for any damage or loss caused or alleged to be caused by or in connection with
          the use of or reliance on any such content, goods, or services available on or through any
          such websites or services.
        </Typography>
        <Typography variant="body1" paragraph>
          We strongly advise You to read the terms and conditions and privacy policies of any third-party websites or services that You visit.
        </Typography>

        <Divider style={{ margin: "20px 0" }} />

        <Typography variant="h5" sx={{fontWeight: 600}} component="h2" gutterBottom>
          Termination
        </Typography>

        <Typography variant="body1" paragraph>
          We may terminate or suspend Your access immediately, without prior notice or liability, for
          any reason whatsoever, including without limitation if You breach these Terms.
        </Typography>

        <Typography variant="body1" paragraph>
          Upon termination, Your right to use the Service will cease immediately.
        </Typography>

        <Divider style={{ margin: "20px 0" }} />

        <Typography variant="h5" sx={{fontWeight: 600}} component="h2" gutterBottom>
          Limitation of Liability
        </Typography>

        <Typography variant="body1" paragraph>
          To the maximum extent permitted by applicable law, in no event shall the Company or its
          suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever
          (including but not limited to, damages for loss of profits, loss of data or other information,
          business interruption, personal injury, or loss of privacy) arising out of or in any way related
          to the use of or inability to use the Service, third-party software, or third-party hardware
          used with the Service, or otherwise in connection with any provision of these Terms, even if
          the Company or any supplier has been advised of the possibility of such damages.
        </Typography>

        <Divider style={{ margin: "20px 0" }} />

        <Typography variant="h5" sx={{fontWeight: 600}} component="h2" gutterBottom>
          "AS IS" and "AS AVAILABLE" Disclaimer
        </Typography>
        <Typography variant="body1" paragraph>
          The Service is provided to You "AS IS" and "AS AVAILABLE" without any warranties of any
          kind. To the maximum extent permitted by law, the Company disclaims all warranties,
          express or implied, with respect to the Service.
        </Typography>
        <Divider style={{ margin: "20px 0" }} />
        <Typography variant="h5" sx={{fontWeight: 600}} component="h2" gutterBottom>
          Governing Law
        </Typography>
        <Typography variant="body1" paragraph>
          The laws of the Country, excluding its conflicts of law rules, shall govern these Terms and
          Your use of the Service. Your use of the Application may also be subject to other local, state,
          or national laws.
        </Typography>

        <Divider style={{ margin: "20px 0" }} />
        <Typography variant="h5" sx={{fontWeight: 600}} component="h2" gutterBottom>
          Dispute Resolution
        </Typography>
        <Typography variant="body1" paragraph>
          If You have any concern or dispute about the Service, You agree to first try to resolve the
          dispute informally by contacting the Company.
        </Typography>

        <Divider style={{ margin: "20px 0" }} />

        <Typography variant="h5" sx={{fontWeight: 600}} component="h2" gutterBottom>
          Severability and Waiver
        </Typography>
        <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>
          Severability
        </Typography>

        <Typography variant="body1" paragraph>
          If any provision of these Terms is held to be unenforceable or invalid, such provision will be
          modified to the greatest extent possible under applicable law, and the remaining provisions
          will continue in full force and effect.
        </Typography>
        <Divider style={{ margin: "20px 0" }} />
        <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>
          Waiver
        </Typography>
        <Typography variant="body1" paragraph>
          Failure to enforce any provision of these Terms will not be considered a waiver of any future
          rights or obligations under these Terms.
        </Typography>
        <Divider style={{ margin: "20px 0" }} />
        <Typography variant="h5" sx={{fontWeight: 600}} component="h2" gutterBottom>
          Changes to These Terms and Conditions
        </Typography>
        <Typography variant="body1" paragraph>
          We reserve the right to modify or replace these Terms at Our sole discretion. If a revision is
          material, we will make reasonable efforts to provide at least 30 days' notice prior to any new
          terms taking effect. What constitutes a material change will be determined at Our sole
          discretion.
        </Typography>
        <Typography variant="body1" paragraph>
          By continuing to access or use Our Service after revisions become effective, You agree to be
          bound by the revised terms. If You do not agree to the new terms, please stop using the
          website and Service.
        </Typography>

        <Divider style={{ margin: "20px 0" }} />
        <Typography variant="h5" sx={{fontWeight: 600}} component="h2" gutterBottom>
          Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about these Terms and Conditions, you can contact us:
        </Typography>
        <ul>
          <li>
            <Typography variant="body1">
              By email: info.beryls@gmail.com
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              By visiting this page on our website: https://www.berylsfinancials.com
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              By phone number: 08038819024</Typography>
          </li>
        </ul>
      </Box>
    </Container>
    <Footer />
    </>
  );
};


export default TermsAndConditions;
